<template>
  <div class="list-form__content">
    <template v-if="count && isScroll">
      <vue-custom-scrollbar
        ref="scroll"
        class="list-form__content-scroll-wrap"
        :settings="{ suppressScrollX: true }"
      >
        <div class="list-form__content-scroll">
          <!-- TODO SLOT -->
          <slot/>
        </div>
      </vue-custom-scrollbar>
    </template>
    <template v-else-if="count && !isScroll">
      <!-- TODO SLOT -->
      <slot/>
    </template>
    <template v-else>
      <div class="no-data">
        <span v-html="L10n('no-data-to-display')" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    count: { type: Number, default: 0 },
    isScroll: { type: Boolean, default: true }
  }
}
</script>

<style lang="stylus">
  .list-form{
    &__content{
      position relative
      flex 1
      min-height 15rem
      &-scroll-wrap{
        position relative
        height 100%
        min-height 15rem
      }
      &-scroll{
        position absolute
        top 0
        left 0
        right 0
        bottom 0
      }
    }
  }
</style>
